import { createApp } from 'vue'
import App from './App.vue'
import router from './router'


// npm install firebase@8.6.5
import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDeGEUOEexT-atvHE4jbb4JVTp5cnU2NPQ",
    authDomain: "krrp-cc5ca.firebaseapp.com",
    projectId: "krrp-cc5ca",
    storageBucket: "krrp-cc5ca.appspot.com",
    messagingSenderId: "432617682502",
    appId: "1:432617682502:web:8f1f4ff8b99cdb9e13fc47"
};

firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

createApp(App).use(router).mount('#app')
